const PRODUCTS = [
  {
    id: 'B007TIE0GQ',
    title: 'Shark Ninja',
    image: 'https://images-na.ssl-images-amazon.com/images/I/51h-a5IaHeL.jpg',
    subtitle:
      'Magic Bullet NutriBullet 12-Piece High-Speed Blender/Mixer System',
    brand: 'Nutribullet',
    reviews: [
      {
        customer: 'ILoveToReview',
        review:
          "I had not seen the infomercial when I purchased this. I was looking for a powerful smoothie maker after my smoothie blender died. The base is MUCH heavier/substantial and well made than the Magic Bullet. It also looks more expensive/nice. I know this because I was at Target examining them both closely. The 600 watts of power has been great to tear through kale, chard, frozen berries, almonds, chia seeds. I love the consistency of the smoothie when I am done. it is not a complete liquid, but really well blended. I love that you keep the nutrition of the pulp. It is not like my first old juicer that left the pulp out of the juice, but also the nutrition. It was a NIGHTMARE to clean. Then I bought the smoothie blender that is now kaput! The Nutri Bullet literally rinses clean in ten seconds. Obviously rinse it right after you are done using it. My daughter won't touch anything green and we put kale, chard, broccoli and fruit,berries to make it NOT green and she likes it. Honestly we are NOT a family that likes kale, chard, broccoli, prunes, but feel so much better now that we are ingesting them. It took about two weeks for me to notice a difference and feel better. My husband and I have been having two a day and I have lost 4 lbs in 18 days without trying. They just keep you full and satisfied. It has taken the edge off my sweet tooth. They will keep you regular.I not sure know why they can not just give you two large smoothie cups. We only use the big size.",
        score: 5,
      },
    ],
    retailer: 'Amazon',
    details: [
      'Effortlessly pulverizes fruits, vegetables, superfoods and protein shakes',
      'High-torque power base and 600-watt motor',
      'Power, patented blade design with cyclonic action',
      'Includes a power base, 1 tall cup, 2 short cups, 1 flat blade and 1 emulsifying blade, 2 re-sealable lids, pocket nutritionist and manual with recipes',
      'This product is manufactured in compliance with US & Canadian Electrical Standards',
    ],
    tags: ['Pantry', 'Obsolete', 'Blender', 'Lightning Deal'],
    sales: [
      {
        weekEnding: '2017-01-01',
        retailSales: 348123,
        wholesaleSales: 255721,
        unitsSold: 887,
        retailerMargin: 123294,
      },
      {
        weekEnding: '2017-01-08',
        retailSales: 256908,
        wholesaleSales: 189678,
        unitsSold: 558,
        retailerMargin: 67230,
      },
      {
        weekEnding: '2017-01-15',
        retailSales: 243522,
        wholesaleSales: 255721,
        unitsSold: 623,
        retailerMargin: 567845,
      },
      {
        weekEnding: '2017-01-22',
        retailSales: 458646,
        wholesaleSales: 356475,
        unitsSold: 745,
        retailerMargin: 453645,
      },
      {
        weekEnding: '2017-01-29',
        retailSales: 929844,
        wholesaleSales: 405784,
        unitsSold: 832,
        retailerMargin: 676577,
      },
      {
        weekEnding: '2017-02-05',
        retailSales: 243522,
        wholesaleSales: 255721,
        unitsSold: 900,
        retailerMargin: 978654,
      },
      {
        weekEnding: '2017-02-12',
        retailSales: 243522,
        wholesaleSales: 255721,
        unitsSold: 432,
        retailerMargin: 342467,
      },
      {
        weekEnding: '2017-02-19',
        retailSales: 243522,
        wholesaleSales: 255721,
        unitsSold: 789,
        retailerMargin: 734523,
      },
      {
        weekEnding: '2017-02-26',
        retailSales: 243522,
        wholesaleSales: 255721,
        unitsSold: 826,
        retailerMargin: 134573,
      },
      {
        weekEnding: '2017-03-05',
        retailSales: 243522,
        wholesaleSales: 255721,
        unitsSold: 904,
        retailerMargin: 423422,
      },
      {
        weekEnding: '2017-03-12',
        retailSales: 243522,
        wholesaleSales: 255721,
        unitsSold: 508,
        retailerMargin: 123466,
      },
      {
        weekEnding: '2017-03-19',
        retailSales: 243880,
        wholesaleSales: 254521,
        unitsSold: 550,
        retailerMargin: 129466,
      },
      {
        weekEnding: '2017-03-26',
        retailSales: 662052,
        wholesaleSales: 378093,
        unitsSold: 698,
        retailerMargin: 99533,
      },
      {
        weekEnding: '2017-04-02',
        retailSales: 165945,
        wholesaleSales: 995034,
        unitsSold: 730,
        retailerMargin: 516961,
      },
      {
        weekEnding: '2017-04-09',
        retailSales: 944774,
        wholesaleSales: 32244,
        unitsSold: 176,
        retailerMargin: 63347,
      },
      {
        weekEnding: '2017-04-16',
        retailSales: 961954,
        wholesaleSales: 876110,
        unitsSold: 110,
        retailerMargin: 171001,
      },
      {
        weekEnding: '2017-04-23',
        retailSales: 31320,
        wholesaleSales: 793023,
        unitsSold: 235,
        retailerMargin: 968592,
      },
      {
        weekEnding: '2017-04-30',
        retailSales: 996174,
        wholesaleSales: 725131,
        unitsSold: 899,
        retailerMargin: 419650,
      },
      {
        weekEnding: '2017-05-07',
        retailSales: 748745,
        wholesaleSales: 526733,
        unitsSold: 0,
        retailerMargin: 781147,
      },
      {
        weekEnding: '2017-05-14',
        retailSales: 206527,
        wholesaleSales: 357796,
        unitsSold: 954,
        retailerMargin: 116289,
      },
      {
        weekEnding: '2017-05-21',
        retailSales: 219886,
        wholesaleSales: 295664,
        unitsSold: 70,
        retailerMargin: 336168,
      },
      {
        weekEnding: '2017-05-28',
        retailSales: 694206,
        wholesaleSales: 914412,
        unitsSold: 487,
        retailerMargin: 688093,
      },
      {
        weekEnding: '2017-06-04',
        retailSales: 550176,
        wholesaleSales: 30485,
        unitsSold: 785,
        retailerMargin: 192444,
      },
      {
        weekEnding: '2017-06-11',
        retailSales: 950385,
        wholesaleSales: 497104,
        unitsSold: 136,
        retailerMargin: 793489,
      },
      {
        weekEnding: '2017-06-18',
        retailSales: 154184,
        wholesaleSales: 171133,
        unitsSold: 941,
        retailerMargin: 219036,
      },
      {
        weekEnding: '2017-06-25',
        retailSales: 929986,
        wholesaleSales: 654481,
        unitsSold: 58,
        retailerMargin: 468615,
      },
      {
        weekEnding: '2017-07-02',
        retailSales: 582966,
        wholesaleSales: 958050,
        unitsSold: 393,
        retailerMargin: 591443,
      },
      {
        weekEnding: '2017-07-09',
        retailSales: 615994,
        wholesaleSales: 684949,
        unitsSold: 858,
        retailerMargin: 585443,
      },
      {
        weekEnding: '2017-07-16',
        retailSales: 277902,
        wholesaleSales: 533123,
        unitsSold: 7,
        retailerMargin: 232085,
      },
      {
        weekEnding: '2017-07-23',
        retailSales: 714227,
        wholesaleSales: 802642,
        unitsSold: 596,
        retailerMargin: 362263,
      },
      {
        weekEnding: '2017-07-30',
        retailSales: 647010,
        wholesaleSales: 308343,
        unitsSold: 404,
        retailerMargin: 262778,
      },
      {
        weekEnding: '2017-08-06',
        retailSales: 256788,
        wholesaleSales: 976758,
        unitsSold: 743,
        retailerMargin: 660243,
      },
      {
        weekEnding: '2017-08-13',
        retailSales: 232111,
        wholesaleSales: 821974,
        unitsSold: 894,
        retailerMargin: 376970,
      },
      {
        weekEnding: '2017-08-20',
        retailSales: 458834,
        wholesaleSales: 205921,
        unitsSold: 903,
        retailerMargin: 482657,
      },
      {
        weekEnding: '2017-08-27',
        retailSales: 26084,
        wholesaleSales: 877868,
        unitsSold: 992,
        retailerMargin: 639437,
      },
      {
        weekEnding: '2017-09-03',
        retailSales: 298974,
        wholesaleSales: 39117,
        unitsSold: 857,
        retailerMargin: 682272,
      },
      {
        weekEnding: '2017-09-10',
        retailSales: 551218,
        wholesaleSales: 208424,
        unitsSold: 113,
        retailerMargin: 257158,
      },
      {
        weekEnding: '2017-09-17',
        retailSales: 108107,
        wholesaleSales: 813976,
        unitsSold: 972,
        retailerMargin: 540079,
      },
      {
        weekEnding: '2017-09-24',
        retailSales: 3381,
        wholesaleSales: 903222,
        unitsSold: 995,
        retailerMargin: 548705,
      },
      {
        weekEnding: '2017-10-01',
        retailSales: 70672,
        wholesaleSales: 656673,
        unitsSold: 270,
        retailerMargin: 458334,
      },
      {
        weekEnding: '2017-10-08',
        retailSales: 551759,
        wholesaleSales: 422642,
        unitsSold: 217,
        retailerMargin: 777812,
      },
      {
        weekEnding: '2017-10-15',
        retailSales: 983322,
        wholesaleSales: 41612,
        unitsSold: 637,
        retailerMargin: 283919,
      },
      {
        weekEnding: '2017-10-22',
        retailSales: 978696,
        wholesaleSales: 427687,
        unitsSold: 224,
        retailerMargin: 853781,
      },
      {
        weekEnding: '2017-10-29',
        retailSales: 140026,
        wholesaleSales: 710663,
        unitsSold: 909,
        retailerMargin: 798857,
      },
      {
        weekEnding: '2017-11-05',
        retailSales: 601628,
        wholesaleSales: 726254,
        unitsSold: 789,
        retailerMargin: 544741,
      },
      {
        weekEnding: '2017-11-12',
        retailSales: 66432,
        wholesaleSales: 916471,
        unitsSold: 491,
        retailerMargin: 296807,
      },
      {
        weekEnding: '2017-11-19',
        retailSales: 450518,
        wholesaleSales: 625939,
        unitsSold: 853,
        retailerMargin: 94781,
      },
      {
        weekEnding: '2017-11-26',
        retailSales: 385909,
        wholesaleSales: 838994,
        unitsSold: 790,
        retailerMargin: 33772,
      },
      {
        weekEnding: '2017-12-03',
        retailSales: 557592,
        wholesaleSales: 893702,
        unitsSold: 346,
        retailerMargin: 682656,
      },
      {
        weekEnding: '2017-12-10',
        retailSales: 832201,
        wholesaleSales: 102479,
        unitsSold: 897,
        retailerMargin: 114349,
      },
      {
        weekEnding: '2017-12-17',
        retailSales: 303739,
        wholesaleSales: 823573,
        unitsSold: 782,
        retailerMargin: 734937,
      },
      {
        weekEnding: '2017-12-24',
        retailSales: 709638,
        wholesaleSales: 753473,
        unitsSold: 855,
        retailerMargin: 110398,
      },
      {
        weekEnding: '2017-12-31',
        retailSales: 798739,
        wholesaleSales: 550042,
        unitsSold: 822,
        retailerMargin: 181968,
      },
    ],
  },
];

export default PRODUCTS;
